import Link from "next/link";
import Image from "next/image";

type HeaderBrandProps = Readonly<{
  href: string;
  name: string;
  logoSrc?: string | null;
  className?: string;
  nameClassName?: string;
}>;

const BLUR_DATA_URL =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN88f7TfwAJBAP6X6u3VAAAAABJRU5ErkJggg==";

export default function HeaderBrand({
  href,
  name,
  logoSrc,
  className = "flex items-center gap-3 shrink-0",
  nameClassName = "text-2xl md:text-3xl font-bold text-primary",
}: HeaderBrandProps) {
  return (
    <Link href={href} className={className}>
      {logoSrc ? (
        <Image
          src={logoSrc}
          alt={name}
          width={48}
          height={48}
          className="h-12 w-12 object-contain"
          placeholder="blur"
          blurDataURL={BLUR_DATA_URL}
        />
      ) : null}
      <span className={nameClassName}>{name}</span>
    </Link>
  );
}
